import Box from "@mui/material/Box";
import { useTheme, type Theme } from "@mui/material/styles";
import {
  AlertCircle,
  AlertTriangle,
  AppWindow,
  Archive,
  ArrowBigDownDash,
  ArrowDown,
  ArrowUp,
  ArrowLeft,
  ArrowRight,
  Blend,
  Building2,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronsLeft,
  ChevronsUpDown,
  CloudCheck,
  CircleQuestionMark,
  CircleX,
  ClipboardList,
  Columns3,
  Component,
  Diamond,
  Download,
  ExternalLink,
  EyeClosed,
  FileSpreadsheet,
  FileText,
  FileX,
  Files,
  Funnel,
  Hash,
  Info,
  LayoutDashboard,
  Lock,
  LogOut,
  Mail,
  MoreHorizontal,
  MoveRight,
  PenLine,
  Pencil,
  Phone,
  Plus,
  Rocket,
  RotateCcw,
  Scale,
  Search,
  Settings,
  SquareArrowLeft,
  Table,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  Users,
  X,
  Zap,
  KeyRound,
  Database,
  Layers,
  Sparkles,
  SendHorizontal,
} from "lucide-react";
import type { ComponentProps, ComponentType, CSSProperties, FC } from "react";

export const AlertCircleIcon = (props: IconProps) => <IconBase Icon={AlertCircle} {...props} />;
export const AlertTriangleIcon = (props: IconProps) => <IconBase Icon={AlertTriangle} {...props} />;
export const AppWindowIcon = (props: IconProps) => <IconBase Icon={AppWindow} {...props} />;
export const ArchiveIcon = (props: IconProps) => <IconBase Icon={Archive} {...props} />;
export const ArrowBigDownDashIcon = (props: IconProps) => <IconBase Icon={ArrowBigDownDash} {...props} />;
export const ArrowDownIcon = (props: IconProps) => <IconBase Icon={ArrowDown} {...props} />;
export const ArrowUpIcon = (props: IconProps) => <IconBase Icon={ArrowUp} {...props} />;
export const BlendIcon = (props: IconProps) => <IconBase Icon={Blend} {...props} />;
export const ArrowLeftIcon = (props: IconProps) => <IconBase Icon={ArrowLeft} {...props} />;
export const ArrowRightIcon = (props: IconProps) => <IconBase Icon={ArrowRight} {...props} />;
export const ComponentIcon = (props: IconProps) => <IconBase Icon={Component} {...props} />;
export const DatabaseIcon = (props: IconProps) => <IconBase Icon={Database} {...props} />;
export const CalendarDaysIcon = (props: IconProps) => <IconBase Icon={CalendarDays} {...props} />;
export const ClipboardListIcon = (props: IconProps) => <IconBase Icon={ClipboardList} {...props} />;
export const CheckIcon = (props: IconProps) => <IconBase Icon={Check} {...props} />;
export const ChevronDownIcon = (props: IconProps) => <IconBase Icon={ChevronDown} {...props} />;
export const ChevronRightIcon = (props: IconProps) => <IconBase Icon={ChevronRight} {...props} />;
export const ChevronsLeftIcon = (props: IconProps) => <IconBase Icon={ChevronsLeft} {...props} />;
export const ChevronsUpDownIcon = (props: IconProps) => <IconBase Icon={ChevronsUpDown} {...props} />;
export const CircleQuestionMarkIcon = (props: IconProps) => <IconBase Icon={CircleQuestionMark} {...props} />;
export const CircleXIcon = (props: IconProps) => <IconBase Icon={CircleX} {...props} />;
export const CloudCheckIcon = (props: IconProps) => <IconBase Icon={CloudCheck} {...props} />;
export const Columns3Icon = (props: IconProps) => <IconBase Icon={Columns3} {...props} />;
export const DownloadIcon = (props: IconProps) => <IconBase Icon={Download} {...props} />;
export const EditIcon = (props: IconProps) => <IconBase Icon={PenLine} {...props} />;
export const ExternalLinkIcon = (props: IconProps) => <IconBase Icon={ExternalLink} {...props} />;
export const EyeClosedIcon = (props: IconProps) => <IconBase Icon={EyeClosed} {...props} />;
export const FileSpreadsheetIcon = (props: IconProps) => <IconBase Icon={FileSpreadsheet} {...props} />;
export const FileTextIcon = (props: IconProps) => <IconBase Icon={FileText} {...props} />;
export const FileXIcon = (props: IconProps) => <IconBase Icon={FileX} {...props} />;
export const FilesIcon = (props: IconProps) => <IconBase Icon={Files} {...props} />;
export const FunnelIcon = (props: IconProps) => <IconBase Icon={Funnel} {...props} />;
export const InfoIcon = (props: IconProps) => <IconBase Icon={Info} {...props} />;
export const LayoutDashboardIcon = (props: IconProps) => <IconBase Icon={LayoutDashboard} {...props} />;
export const LockIcon = (props: IconProps) => <IconBase Icon={Lock} {...props} />;
export const LogOutIcon = (props: IconProps) => <IconBase Icon={LogOut} {...props} />;
export const MailIcon = (props: IconProps) => <IconBase Icon={Mail} {...props} />;
export const MoreHorizontalIcon = (props: IconProps) => <IconBase Icon={MoreHorizontal} {...props} />;
export const MoveRightIcon = (props: IconProps) => <IconBase Icon={MoveRight} {...props} />;
export const PencilIcon = (props: IconProps) => <IconBase Icon={Pencil} {...props} />;
export const PhoneIcon = (props: IconProps) => <IconBase Icon={Phone} {...props} />;
export const PlusIcon = (props: IconProps) => <IconBase Icon={Plus} {...props} />;
export const RotateCcwIcon = (props: IconProps) => <IconBase Icon={RotateCcw} {...props} />;
export const SearchIcon = (props: IconProps) => <IconBase Icon={Search} {...props} />;
export const SettingsIcon = (props: IconProps) => <IconBase Icon={Settings} {...props} />;
export const SquareArrowLeftIcon = (props: IconProps) => <IconBase Icon={SquareArrowLeft} {...props} />;
export const TableIcon = (props: IconProps) => <IconBase Icon={Table} {...props} />;
export const TrashCanIcon = (props: IconProps) => <IconBase Icon={Trash2} {...props} />;
export const TriangleAlertIcon = (props: IconProps) => <IconBase Icon={TriangleAlert} {...props} />;
export const UploadIcon = (props: IconProps) => <IconBase Icon={Upload} {...props} />;
export const UsersIcon = (props: IconProps) => <IconBase Icon={Users} {...props} />;
export const UserIcon = (props: IconProps) => <IconBase Icon={User} {...props} />;
export const XIcon = (props: IconProps) => <IconBase Icon={X} {...props} />;
export const YesIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" style={useCustomSvgIconStyle(props)}>
    <g stroke="none" fill="none">
      <path
        d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
      <path
        d="M17.0355339,8.29289322 C17.4260582,8.68341751 17.4260582,9.31658249 17.0355339,9.70710678 L11.0355339,15.7071068 C10.8853323,15.8573084 10.699237,15.9497402 10.5048586,15.9844021 L10.3874582,15.9982669 L10.2693957,15.9982669 C10.0334911,15.9844021 9.80156232,15.8873488 9.62132034,15.7071068 L6.79289319,12.8786796 C6.40236891,12.4881553 6.40236894,11.8549903 6.79289325,11.4644661 C7.18341756,11.0739418 7.81658254,11.0739418 8.20710681,11.4644661 L10.328,13.585 L15.6213203,8.29289322 C16.0118446,7.90236893 16.6450096,7.90236893 17.0355339,8.29289322 Z"
        fill="#ffffff"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
export const PDFIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" style={useCustomSvgIconStyle(props)}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.8 1c2.445 0 3.99 1.587 4.088 4.57l.022.44.029.855.023 1.048.022 1.62.01 1.774v1.82l-.013 1.76-.012.823-.023 1.125-.031.954-.026.519a4.55 4.55 0 0 1-1.356 3.39c-.906.89-2.142 1.362-3.32 1.301l-.309.011-1.037.022-1.35.013h-2.675l-1.683-.015-1.26-.026-.472-.02c-2.581-.141-4.144-1.05-4.295-3.504a43.83 43.83 0 0 1-.019-.327l-.032-.704-.027-.766-.02-.823-.021-1.327-.008-.938v-1.276l.009-1.366.018-1.267.026-1.09.024-.655A5.151 5.151 0 0 1 4.4 5.781a24.92 24.92 0 0 1 3.523-3.474C8.827 1.543 9.95 1.086 11.2 1h5.6Zm-4.956 1.997-.17.019c-.421.08-.776.849-.891 2.625l-.013.233.003.11a2.82 2.82 0 0 1-.69 1.807l-.136.146a2.82 2.82 0 0 1-1.954.826L7.87 8.76l-.213.013c-1.644.11-2.452.525-2.592 1.052l-.014.067-.02.843-.018 1.244-.009 1.343.001 1.263.007.92.013.88.028 1.226.026.748.031.683.018.316c.072 1.163.714 1.536 2.399 1.63l.3.013.693.018 1.467.02 2.602.01 1.572-.009 1.288-.018.77-.02a2.55 2.55 0 0 0 1.911-.73c.508-.5.783-1.188.762-1.989l.03-.691.026-.844.02-.966.018-1.43.009-1.53v-1.267l-.008-1.662-.018-1.542-.033-1.57-.03-.805-.026-.533C18.772 3.653 18.087 3 16.8 3l-4.956-.003Zm-3.741 8.602c.55 0 .972.143 1.264.429.293.286.439.689.439 1.209 0 .52-.146.923-.439 1.209-.292.286-.714.429-1.264.429h-.754V16a.5.5 0 0 1-.5.5h-.274a.5.5 0 0 1-.5-.5v-3.901a.5.5 0 0 1 .5-.5h1.528Zm4.264 0c.333 0 .647.067.94.201.292.135.547.314.766.537.219.223.391.483.517.78.125.297.188.607.188.932a2.48 2.48 0 0 1-1.466 2.249 2.239 2.239 0 0 1-.945.202h-1.385a.5.5 0 0 1-.5-.5v-3.901a.5.5 0 0 1 .5-.5h1.385Zm5.253 0a.5.5 0 0 1 .5.5v.079a.5.5 0 0 1-.5.5h-1.034v.819h.898a.5.5 0 0 1 .5.5v.079a.5.5 0 0 1-.5.5h-.898V16a.5.5 0 0 1-.5.5h-.274a.5.5 0 0 1-.5-.5v-3.901a.5.5 0 0 1 .5-.5h1.808Zm-5.572 1.079h-.292v2.743h.292c.221 0 .418-.035.592-.104.173-.07.32-.165.439-.286.119-.121.21-.265.273-.432.062-.167.094-.35.094-.55 0-.194-.033-.377-.098-.545a1.257 1.257 0 0 0-.276-.436 1.263 1.263 0 0 0-.439-.286 1.563 1.563 0 0 0-.585-.104Zm-4.277-.052H7.35v1.222h.422c.468 0 .702-.204.702-.611 0-.407-.234-.611-.702-.611Zm1.197-8.588-.212.176A23.153 23.153 0 0 0 6.29 6.647l-.302.352.286-.062c.39-.076.81-.13 1.259-.16l.27-.016h.104a.82.82 0 0 0 .863-.749l.001-.222c.032-.643.097-1.229.197-1.752Z"
    />
  </svg>
);

const DEFAULT_SIZE = 16;
export type IconProps = {
  /** Defaults to currentColor */
  color?: string | ((theme: Theme) => string);
  /** Defaults to the font size of the parent */
  size?: number;
  rotate?: number;
  strokeWidth?: number;
} & Omit<ComponentProps<"svg">, "color" | "style">;

type InternalIconProps = { color?: string; style?: CSSProperties; size?: number; strokeWidth?: number };
const IconBase = ({
  Icon,
  color,
  size = 16,
  strokeWidth,
  rotate,
  ...svgProps
}: IconProps & { Icon: ComponentType<InternalIconProps> }) => {
  const theme = useTheme();

  return (
    <Icon
      {...svgProps}
      strokeWidth={strokeWidth}
      size={size}
      style={{ transform: rotate ? `rotate(${rotate}deg)` : undefined, flexShrink: 0 }}
      color={typeof color === "string" ? color : color?.(theme)}
    />
  );
};

const useCustomSvgIconStyle = ({ size = DEFAULT_SIZE, rotate, color, strokeWidth }: IconProps): CSSProperties => {
  const theme = useTheme();
  return {
    height: size,
    width: size,
    transform: rotate ? `rotate(${rotate}deg)` : undefined,
    color: typeof color === "string" ? color : color?.(theme),
    strokeWidth,
  };
};

type InternalIconWithBackgroundProps = Record<"color" | "borderColor" | "backgroundColor", (theme: Theme) => string> & {
  Icon: ComponentType<InternalIconProps>;
};

export type IconWithBackgroundProps = { size: IconWithBackgroundSize };
type IconWithBackgroundSize = "sm" | "md";

const BORDER_WIDTH = 1;
export const IconWithBackground = ({
  Icon,
  size,
  color,
  borderColor,
  backgroundColor,
}: InternalIconWithBackgroundProps & IconWithBackgroundProps) => {
  const sizes: Record<
    IconWithBackgroundSize,
    { iconSize: number; bgSize: number; borderRadius: string; borderColor: (theme: Theme) => string }
  > = {
    sm: { iconSize: 14, bgSize: 24, borderRadius: "6px", borderColor },
    md: { iconSize: 18, bgSize: 36, borderRadius: "9px", borderColor: theme => theme.lighten(borderColor(theme), 0.4) },
  };

  const sizeProps = sizes[size];

  return (
    <Box
      sx={{
        flexShrink: 0,
        width: sizeProps.bgSize,
        height: sizeProps.bgSize,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `${BORDER_WIDTH}px solid`,
        borderColor: sizeProps.borderColor,
        borderRadius: sizeProps.borderRadius,
        backgroundColor,
      }}
    >
      <IconBase Icon={Icon} size={sizeProps.iconSize} color={color} />
    </Box>
  );
};

/** Entity Icons */

/** Registration Controller  */

const RegistrationBaseIcon: FC<IconProps> = props => (
  <svg viewBox="0 0 24 24" style={useCustomSvgIconStyle(props)}>
    <g stroke="none" fill="none">
      <rect
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        x="2"
        y="4"
        width="20"
        height="16"
        rx="2"
      ></rect>
      <g strokeWidth="1" fillRule="evenodd" transform="translate(5.505, 8.5)">
        <g
          transform="translate(0.495, 0.25)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        >
          <line x1="0.495" y1="0.5" x2="0.505" y2="0.5"></line>
        </g>
        <g
          transform="translate(0.495, 5.5)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        >
          <line x1="0.495" y1="0.5" x2="0.505" y2="0.5"></line>
        </g>
        <rect fill="currentColor" x="4.195" y="-0.1" width="8.5" height="1.75" rx="0.875"></rect>
        <rect fill="currentColor" x="4.195" y="5" width="8.5" height="1.75" rx="0.875"></rect>
      </g>
    </g>
  </svg>
);

export const RegistrationControllerIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandBlue["800"]}
    borderColor={theme => theme.palette.brandBlue["800"]}
    color={theme => theme.palette.brandBlue["50"]}
    Icon={RegistrationBaseIcon}
    {...props}
  />
);
export const RegistrationControllerIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandBlue["50"]}
    borderColor={theme => theme.palette.brandBlue["400"]}
    color={theme => theme.palette.brandBlue["600"]}
    Icon={RegistrationBaseIcon}
    {...props}
  />
);
export const RegistrationControllerIcon3 = (props: IconProps) => <RegistrationBaseIcon {...props} />;

/** Registration Processor */
export const RegistrationProcessorIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandBlue["500"]}
    borderColor={theme => theme.palette.brandBlue["500"]}
    color={theme => theme.palette.brandBlue["50"]}
    Icon={RegistrationBaseIcon}
    {...props}
  />
);
export const RegistrationProcessorIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandBlue["50"]}
    borderColor={theme => theme.palette.brandBlue["400"]}
    color={theme => theme.palette.brandBlue["600"]}
    Icon={RegistrationBaseIcon}
    {...props}
  />
);

/** System Icons */
export const SystemIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.purple["400"]}
    borderColor={theme => theme.palette.purple["400"]}
    color={theme => theme.palette.purple["50"]}
    Icon={AppWindow}
    {...props}
  />
);

export const SystemIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.purple["50"]}
    borderColor={theme => theme.palette.purple["300"]}
    color={theme => theme.palette.purple["500"]}
    Icon={AppWindow}
    {...props}
  />
);
export const SystemIcon3 = (props: IconProps) => <IconBase Icon={AppWindow} {...props} />;

/** Partner Icons */
export const PartnerIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandOrange["100"]}
    borderColor={theme => theme.palette.brandOrange["500"]}
    color={theme => theme.palette.brandOrange["600"]}
    Icon={Building2}
    {...props}
  />
);
export const PartnerIcon3 = (props: IconProps) => <IconBase Icon={Building2} {...props} />;

/** DPIA Icons */
export const DpiaIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    color={theme => theme.palette.teal["50"]}
    backgroundColor={theme => theme.palette.teal["500"]}
    borderColor={theme => theme.palette.teal["500"]}
    Icon={Scale}
    {...props}
  />
);
export const DpiaIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.teal["100"]}
    borderColor={theme => theme.palette.teal["500"]}
    color={theme => theme.palette.teal["600"]}
    Icon={Scale}
    {...props}
  />
);
export const DpiaIcon3 = (props: IconProps) => <IconBase Icon={Scale} {...props} />;

/** Option Category Icons */

export const OptionCategoryIcon3 = (props: IconProps) => <IconBase Icon={Hash} {...props} />;

/** Risk Icons */
export const RiskIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandRed["500"]}
    borderColor={theme => theme.palette.brandRed["500"]}
    color={theme => theme.palette.brandRed["50"]}
    Icon={Zap}
    {...props}
  />
);
export const RiskIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandRed["100"]}
    borderColor={theme => theme.palette.brandRed["400"]}
    color={theme => theme.palette.brandRed["500"]}
    Icon={Zap}
    {...props}
  />
);
export const RiskIcon3 = (props: IconProps) => <IconBase Icon={Zap} {...props} />;

/** Measure Icons */
export const MeasureIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandGreen["50"]}
    borderColor={theme => theme.palette.brandGreen["500"]}
    color={theme => theme.palette.brandGreen["700"]}
    Icon={Rocket}
    {...props}
  />
);
export const MeasureIcon3 = (props: IconProps) => <IconBase Icon={Rocket} {...props} />;

/** Person Icons */
export const PersonIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.grey["600"]}
    borderColor={theme => theme.palette.grey["600"]}
    color={theme => theme.palette.ink["50"]}
    Icon={User}
    {...props}
  />
);
export const PersonIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.grey["200"]}
    borderColor={theme => theme.palette.grey["500"]}
    color={theme => theme.palette.text.tertiary}
    Icon={User}
    {...props}
  />
);
export const PersonIcon3 = (props: IconProps) => <IconBase Icon={User} {...props} />;

/** Tenant Icons */
export const TenantIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.brandOrange["100"]}
    borderColor={theme => theme.palette.brandOrange["500"]}
    color={theme => theme.palette.brandOrange["600"]}
    Icon={Diamond}
    {...props}
  />
);
export const TenantIcon3 = (props: IconProps) => <IconBase Icon={Diamond} {...props} />;

/** Permission Icons */
export const PermissionIcon1 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.grey["600"]}
    borderColor={theme => theme.palette.grey["600"]}
    color={theme => theme.palette.ink["50"]}
    Icon={KeyRound}
    {...props}
  />
);
export const PermissionIcon3 = (props: IconProps) => <IconBase Icon={KeyRound} {...props} />;

/** Information Type Icons */
export const InformationTypeIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.blue["50"]}
    borderColor={theme => theme.palette.blue["300"]}
    color={theme => theme.palette.blue["600"]}
    Icon={Layers}
    {...props}
  />
);
export const InformationTypeIcon3 = (props: IconProps) => <IconBase Icon={Layers} {...props} />;

export const ArchivedIcon2 = (props: IconWithBackgroundProps) => (
  <IconWithBackground
    backgroundColor={theme => theme.palette.grey["100"]}
    borderColor={theme => theme.palette.grey["300"]}
    color={theme => theme.palette.text.tertiary}
    Icon={Archive}
    {...props}
  />
);
export const SparklesIcon = (props: IconProps) => <IconBase Icon={Sparkles} {...props} />;
export const SendIcon = (props: IconProps) => <IconBase Icon={SendHorizontal} {...props} />;
